import { ROVO_CHAT_CLIENT_ID } from '@atlassian/rovo-content-bridge-api-commands/clients/rovo-chat-client';
import { ROVO_INLINE_INPUT_BOX_CLIENT_ID } from '@atlassian/rovo-content-bridge-api-commands/clients/rovo-inline-input-box-client';
import { InlineInputBoxAbortMessageCommand } from '@atlassian/rovo-content-bridge-api-commands/commands/inline-input-box-abort-message-command';
import { useRovoContentBridgeAPI } from '@atlassian/rovo-content-bridge-api/hooks';

/**
 * Hook to handle discarding Rovo inline input box operations.
 *
 * @returns { abort: () => void } - Function to abort Rovo inline input box operations.
 */
export const useRovoAbort = () => {
	const { send } = useRovoContentBridgeAPI(ROVO_INLINE_INPUT_BOX_CLIENT_ID);

	return {
		abort: (): void => {
			send(InlineInputBoxAbortMessageCommand, {
				receiverId: ROVO_CHAT_CLIENT_ID,
			});
		},
	};
};
